export default __webpack_public_path__ + "static/media/loader.92e5b476.svg";